import { useContext } from "react";
import { DemoContext } from "../context/DemoContext";

export function useDemo() {
  const context = useContext(DemoContext);
  if (context === undefined) {
    throw new Error("useDemo must be used within DemoProvider");
  }
  return context;
}
